module.exports = __webpack_public_path__ + "static/media/app-demo.1dcf4874.png";